import React, {useEffect, useState} from 'react';
import { Wrapper } from './style';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

// Components
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchInput from 'components/common/SearchInput';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Link from 'components/common/Link';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';

const DropDown = ({ specialties, cities, educationLevels, label, items, name, placeholder, searchValue, handleSearch, searchBar, expand }) => {
    const router = useRouter();
	const {webConfig} = useSelector(state => state.core);
    const [expanded, setExpanded] = useState(expand);
    let { city, specialty, educationLevel, lang } = router.query;
    let queries = {};
    if (!city) {
        city = 'IR';
    }
    if (!specialty) {
        specialty = 'all';
    }
    if (!educationLevel) {
        educationLevel = 'all';
    }
    if (lang && lang !== 'fa') {
        queries['lang'] = lang;
    }

    const handleExpansion = () => {
      setExpanded((prevExpanded) => !prevExpanded);
    };

    useEffect(() => {
        setExpanded(expand);
    }, [expand])

    return(
    <Wrapper webConfig={webConfig}>
        <Accordion
            className="accordion"
            expanded={expanded}
        >
            <AccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
                className="accordion"
                expandIcon={<ExpandMoreIcon onClick={handleExpansion} />}
            >
                <div className='header'>
                <span className='label'>
                    {label}
                </span>
                {name === 'specialty' && specialty !== 'all' ?
                <div className='chip'>
                    {specialties.filter(i => (i.Slug === specialty))[0]?.Title}
                    <CloseIcon 
                        onClick={() => router.push(`/explore/doctors/${educationLevel}/all/city/${city}`)}
                    />
                </div>
                : name === 'city' && city !== 'IR' ?
                <div className='chip'>
                    {webConfig.lang === 'fa' ?
                    cities.filter(i =>  (i.Slug === city))[0]?.Title
                    :
                    cities.filter(i =>  (i.Slug === city))[0]?.Slug
                    }
                    <CloseIcon 
                        onClick={() => router.push(`/explore/doctors/${educationLevel}/${specialty}/city/IR`)}
                    />
                </div>
                : name === 'educationLevel' && educationLevel !== 'all' ?
                <div className='chip'>
                    {educationLevels.filter(i => (i.Slug === educationLevel))[0]?.Title}
                    <CloseIcon 
                        onClick={() => router.push(`/explore/doctors/all/${specialty}/city/${city}`)}
                    />
                </div>
            : null}
            </div>
            </AccordionSummary>

            <AccordionDetails
                className="accordion-detail"
            >   
                {searchBar &&
                <SearchInput 
                    name={name}
                    defaultValue={searchValue}
                    handleChange={handleSearch}
                    placeholder={placeholder}
                />
                }
                <div>
                <div className='items'>
                    {items.map(i => (
                    <div className='item'>
                        <Link
                            className="label"
                            to={
                                name === 'specialty' ? `/explore/doctors/${educationLevel}/${i.Slug}/city/${city}` 
                                : name === 'city' ? `/explore/doctors/${educationLevel}/${specialty}/city/${i.Slug}` 
                                : name === 'educationLevel' ? `/explore/doctors/${i.Slug}/${specialty}/city/${city}`
                                : null
                            }
                            params={queries}
                        >
                            <Checkbox 
                                checked={
                                    name === 'specialty' ? specialty === i.Slug 
                                    : name === 'city' ? city === i.Slug 
                                    : name === 'educationLevel' ? educationLevel === i.Slug 
                                    : null
                                }
                                name={name}
                                value={i.Slug}
                                disableRipple
                                icon={
                                    <span className='span' />
                                }        
                                checkedIcon={ 
                                    <span className='span tick' />
                                }
                            />
                            {lang && lang !== 'fa' && name === 'city' ? i.Slug : i.Title}
                        </Link>
                    </div>
                    ))}
                    </div>
                </div>
            </AccordionDetails>
        </Accordion>
    </Wrapper>
    )
}

export default DropDown;